<template>
  <span class="vv-radio-color">
    <input
      type="radio"
      :name="name"
      :value="value"
      :id="value"
      :checked="checked"
      @change="onChange"
    />
    <label :for="value">
      <div class="hexagon" :style="{ color: color }"></div>
      <div>{{ label }}</div>
    </label>
  </span>
</template>

<script>
export default {
  name: 'VvRadioBubble',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    color: String,
    name: String,
    value: String | Number,
    label: String,
    modelValue: String,
  },
  computed: {
    checked() {
      return this.modelValue === this.value
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/hexagon.scss';

.vv-radio-color {
  text-align: center;

  label {
    display: inline-block;
    padding: 10px;
    width: 88px;
    margin: 8px; // leave place for the border when checked
    border-radius: 18.5px;
    box-shadow: 1px 2px 10px 0 rgba(183, 183, 183, 0.5);
    background-color: #ffffff;
    font-family: Avenir;
    font-size: 12px;
    font-weight: 900;
    color: $font-color;
    cursor: pointer;
  }

  input {
    display: none;
  }

  input:checked + label {
    border: solid 2px $primary;
    margin: 6px;
  }

  
}
</style>
